// Mock data for Webrionix agency website

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "CEO, Luxe Coaching",
    text: "Webrionix transformed our online presence. Our conversion rate increased by 340% in just 2 months!",
    rating: 5,
    industry: "Coaching & Consulting"
  },
  {
    id: 2,
    name: "Rajesh Patel",
    role: "Founder, TechForge Manufacturing",
    text: "Professional, fast, and understood our B2B needs perfectly. The website has been a game-changer for lead generation.",
    rating: 5,
    industry: "Manufacturing"
  },
  {
    id: 3,
    name: "Michael Chen",
    role: "Trading Coach",
    text: "They built my trading journal platform exactly as envisioned. Clean, fast, and converts visitors into students.",
    rating: 5,
    industry: "Finance & Trading"
  },
  {
    id: 4,
    name: "Emily Rodriguez",
    role: "Owner, Boutique Beauty",
    text: "Our e-commerce site looks premium and works flawlessly. Sales have doubled since the redesign!",
    rating: 5,
    industry: "E-commerce"
  },
  {
    id: 5,
    name: "Priya Sharma",
    role: "Founder, Wellness by Priya",
    text: "Webrionix delivered a stunning website for my coaching business. The design is elegant and my booking rate has tripled!",
    rating: 5,
    industry: "Health & Wellness"
  },
  {
    id: 6,
    name: "Arjun Mehta",
    role: "CEO, Digital Marketing Pro",
    text: "Best decision we made! Our landing page now converts at 38%. The team understood our vision perfectly and delivered fast.",
    rating: 5,
    industry: "Digital Marketing"
  }
];

export const services = [
  {
    id: 1,
    title: "Business Website",
    description: "Professional websites that establish credibility and convert visitors into customers.",
    features: ["Custom Design", "Mobile Responsive", "SEO Optimized", "Contact Forms"],
    benefits: "Establish your online presence with a website that builds trust and drives results.",
    idealFor: "Small businesses, consultants, service providers",
    icon: "Globe",
    price: "Starting at $249"
  },
  {
    id: 2,
    title: "Landing Page",
    description: "High-converting single-page websites designed to turn traffic into leads and sales.",
    features: ["Conversion Focused", "A/B Testing Ready", "Fast Loading", "Lead Capture"],
    benefits: "Maximize ROI from your marketing campaigns with pages built to convert.",
    idealFor: "Product launches, lead generation, marketing campaigns",
    icon: "Target",
    price: "Starting at $149"
  },
  {
    id: 3,
    title: "Personal Brand Website",
    description: "Showcase your expertise and attract opportunities with a stunning personal portfolio.",
    features: ["Portfolio Showcase", "Blog Integration", "Social Links", "Contact System"],
    benefits: "Stand out in your industry and attract your dream clients or opportunities.",
    idealFor: "Coaches, creators, freelancers, professionals",
    icon: "User",
    price: "Starting at $149"
  },
  {
    id: 4,
    title: "Personalized Website",
    description: "Create a unique, heartfelt website for someone special - perfect for gifts, celebrations, or memories.",
    features: ["Custom Theme", "Photo Gallery", "Personal Messages", "Interactive Elements"],
    benefits: "Give the gift of a personalized digital experience that lasts forever.",
    idealFor: "Birthdays, anniversaries, weddings, special occasions",
    icon: "Heart",
    price: "Starting at $49"
  },
  {
    id: 5,
    title: "Startup Website",
    description: "Launch-ready websites for your new venture with modern design and growth-focused features.",
    features: ["Modern UI/UX", "Lead Generation", "Analytics Setup", "Scalable Design"],
    benefits: "Get your startup online quickly with a professional website that grows with you.",
    idealFor: "New startups, entrepreneurs, early-stage ventures",
    icon: "Rocket",
    price: "Starting at $49"
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "Elite Trading Academy",
    category: "Education Platform",
    description: "A comprehensive trading education platform with course management, student dashboard, and payment integration.",
    image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?crop=entropy&cs=srgb&fm=jpg",
    tags: ["SaaS", "Education", "Payment Integration"],
    results: "+250% student enrollments",
    link: "#"
  },
  {
    id: 2,
    title: "Precision Engineering Co.",
    category: "B2B Manufacturing",
    description: "Professional B2B website showcasing industrial capabilities with lead generation focus.",
    image: "https://images.unsplash.com/photo-1547658719-da2b51169166?crop=entropy&cs=srgb&fm=jpg",
    tags: ["Corporate", "B2B", "Lead Generation"],
    results: "+180% qualified leads",
    link: "#"
  },
  {
    id: 3,
    title: "Wellness Coach Landing",
    category: "Personal Brand",
    description: "High-converting landing page for health coaching program with integrated booking system.",
    image: "https://images.unsplash.com/photo-1486486955648-a4f22566c598?crop=entropy&cs=srgb&fm=jpg",
    tags: ["Landing Page", "Coaching", "Conversion Optimized"],
    results: "43% conversion rate",
    link: "#"
  },
  {
    id: 4,
    title: "Artisan Market",
    category: "E-commerce",
    description: "Modern e-commerce store for handcrafted products with seamless checkout experience.",
    image: "https://images.unsplash.com/photo-1472851294608-062f824d29cc?crop=entropy&cs=srgb&fm=jpg",
    tags: ["E-commerce", "Shopify", "Mobile First"],
    results: "+320% online sales",
    link: "#"
  },
  {
    id: 5,
    title: "FinTech Startup",
    category: "SaaS Platform",
    description: "Investment tracking dashboard with real-time data visualization and portfolio management.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg",
    tags: ["FinTech", "Dashboard", "Real-time Data"],
    results: "Successful Series A launch",
    link: "#"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Business Website",
    price: "$249",
    description: "Professional website for small businesses and service providers",
    features: [
      "Up to 5 pages",
      "Mobile responsive design",
      "Basic SEO optimization",
      "Contact form integration",
      "2 rounds of revisions",
      "7-10 day delivery",
      "30 days support",
      "Custom domain setup"
    ],
    popular: false,
    cta: "Get Started"
  },
  {
    id: 2,
    name: "Landing Page",
    price: "$149",
    description: "High-converting single page for campaigns and lead generation",
    features: [
      "Single page design",
      "Conversion optimized",
      "Fast loading speed",
      "Lead capture form",
      "Mobile responsive",
      "1 round of revisions",
      "5-7 day delivery",
      "15 days support"
    ],
    popular: false,
    cta: "Get Started"
  },
  {
    id: 3,
    name: "Personal Brand",
    price: "$149",
    description: "Perfect portfolio website for professionals and creators",
    features: [
      "Up to 4 pages",
      "Portfolio showcase",
      "Blog integration",
      "Social media links",
      "Mobile responsive",
      "2 rounds of revisions",
      "7 day delivery",
      "30 days support"
    ],
    popular: true,
    cta: "Most Popular"
  },
  {
    id: 4,
    name: "Personalized Website",
    price: "$49",
    description: "Unique website for someone special - perfect gift for any occasion",
    features: [
      "Single page design",
      "Custom theme & colors",
      "Photo gallery",
      "Personal messages",
      "Music integration",
      "1 round of revisions",
      "3-5 day delivery",
      "15 days support"
    ],
    popular: false,
    cta: "Create Gift"
  },
  {
    id: 5,
    name: "Startup Website",
    price: "$49",
    description: "Quick launch website for new ventures and entrepreneurs",
    features: [
      "Up to 3 pages",
      "Modern design",
      "Mobile responsive",
      "Basic SEO",
      "Contact form",
      "1 round of revisions",
      "5 day delivery",
      "15 days support"
    ],
    popular: false,
    cta: "Launch Now"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Conversion-Focused Design",
    description: "Every element is strategically placed to guide visitors toward taking action.",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Fast Delivery",
    description: "Get your website live in 7-21 days, depending on complexity.",
    icon: "Zap"
  },
  {
    id: 3,
    title: "SEO-Ready",
    description: "Built with best practices to help you rank higher on search engines.",
    icon: "Search"
  },
  {
    id: 4,
    title: "Mobile Optimized",
    description: "Flawless experience on all devices - desktop, tablet, and mobile.",
    icon: "Smartphone"
  },
  {
    id: 5,
    title: "Modern UI/UX",
    description: "Contemporary designs that match the quality of top-tier agencies.",
    icon: "Palette"
  },
  {
    id: 6,
    title: "Affordable Pricing",
    description: "Premium quality without the agency premium price tag.",
    icon: "DollarSign"
  }
];

export const stats = [
  { value: "150+", label: "Websites Delivered" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "2.5x", label: "Avg. Conversion Increase" },
  { value: "7-21", label: "Days Delivery Time" }
];

export const faqs = [
  {
    id: 1,
    question: "How long does it take to build a website?",
    answer: "Delivery time depends on the package: Starter (7-10 days), Professional (10-14 days), Premium (14-21 days). Rush delivery available for an additional fee."
  },
  {
    id: 2,
    question: "Do you provide hosting and domain setup?",
    answer: "Yes! We can assist with domain registration and hosting setup. We'll guide you through the process or handle it completely for you."
  },
  {
    id: 3,
    question: "Can I update the website myself after it's built?",
    answer: "Absolutely! We build websites with user-friendly CMS options that allow you to make updates easily. We also provide training and documentation."
  },
  {
    id: 4,
    question: "What if I need changes after the project is complete?",
    answer: "All packages include post-launch support (30-90 days depending on plan). After that, we offer maintenance packages or hourly rates for updates."
  },
  {
    id: 5,
    question: "Do you offer payment plans?",
    answer: "Yes, we offer flexible payment plans: 50% upfront and 50% upon completion. For Premium packages, we can split into 3 installments."
  },
  {
    id: 6,
    question: "What industries do you specialize in?",
    answer: "We work with coaches, consultants, traders, manufacturing businesses, e-commerce stores, personal brands, and SaaS startups."
  }
];

export const contactInfo = {
  email: "hello@webrionix.com",
  phone: "",
  address: "New Delhi, India",
  social: {
    twitter: "https://twitter.com/webrionix",
    linkedin: "https://linkedin.com/company/webrionix",
    instagram: "https://instagram.com/webrionix",
    github: "https://github.com/webrionix"
  }
};
